import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/navbar";
import MicrogridFilterBar from "../../components/Filters/filters";
import MetricsContainer from "../../components/Microgrid-Opt-Components/Metrics/metrics-container";
import MicrogridChartsTab from "./charts-tab";
import { RootContext } from "../../contexts/root-context";
import { useQuery } from "@tanstack/react-query";
import { BASE_URL } from "../../strings";
import { RATINGEN_MEASURES } from "../../features/ratingen/payloads/payload";

// Define the headers object outside the component to avoid recreation on each render
const headers = { 'Content-Type': 'application/json' };

const RatingenInit = () => {
    const { ratingenTimePeriod } = useContext(RootContext);
    const [data, setData] = useState({
        "BHKW_Gesamtbezug_ABB_Wirk_Plus_1_Energie": "0",
        "BHKW_Gesamteinspeisung_ABB_Wirk_Minus_2_Energie": "0",
        "BHKW_Generator1_71282_Energie": "0",
        "BHKW_Generator2_71284_Energie": "0",
        "Verwaltungsgebaude_UG_Station4_PV_1951063_Energie": "0",
        "Wasser_Hauptzugang_G69927_2100001_13_Wasser_Durchflussmenge": "0",
        "Normvolumen_Gas_7_732_96_05_18_Durchflussmenge": "0",
        "Empfang_PV_Anlage_UV_rechts_oben_1395203": "0"
    });

    const { data: summaryData, isSuccess } = useQuery({
        queryKey: ['ratingenMetrics', ratingenTimePeriod],
        retry: 5,
        queryFn: async () => {
            const response = await fetch(`${BASE_URL}/trend-graph?` + new URLSearchParams({
                site: 'ratingen',
                time_period: ratingenTimePeriod,
                data_type: 'summary',
                measure: RATINGEN_MEASURES.join(",")
            }), {
                method: 'POST',
                headers: headers,
            });
            return await response.json();
        }
    })

    useEffect(() => {
        if (isSuccess && summaryData) {
            setData(summaryData);
        }
    }, [isSuccess, summaryData, ratingenTimePeriod]);

    return (
        <>
            <Navbar />
            <MicrogridFilterBar />
            <MetricsContainer data={data} />
            <MicrogridChartsTab data={data} />

        </>
    );
};

export default React.memo(RatingenInit);
